import request from '@/utils/request'

// 获取投放组列表
export function getReleaseGroupList(params = {}) {
  return request({
    url: '/ocean_novel_report/release_group',
    method: 'get',
    params
  })
}

// 添加投放组
export function addReleaseGroup(data = {}) {
  return request({
    url: '/ocean_novel_report/release_group',
    method: 'post',
    data
  })
}

// 更新投放组
export function updateReleaseGroup(data = {}) {
  return request({
    url: `/ocean_novel_report/release_group/${data.id}`,
    method: 'PUT',
    data
  })
}

// 获取投放组投手列表
export function getListOfPitchersInTheLaunchGroup(params = {}) {
  return request({
    url: `/ocean_novel_report/release_group_user`,
    method: 'get',
    params
  })
}

// 添加投放组投手
export function addOfPitchersInTheLaunchGroup(data = {}) {
  return request({
    url: `/ocean_novel_report/release_group_user_add`,
    method: 'post',
    data
  })
}

// 删除投放组投手
export function deleteOfPitchersInTheLaunchGroup(data = {}) {
  return request({
    url: `/ocean_novel_report/release_group_user_del`,
    method: 'DELETE',
    data
  })
}

// 获取运营组列表
export function getOperationGroupList(params = {}) {
  return request({
    url: `/ocean_novel_report/operation_group`,
    method: 'GET',
    params
  })
}

// 添加运营组
export function addOperationGroup(data = {}) {
  return request({
    url: `/ocean_novel_report/operation_group`,
    method: 'post',
    data
  })
}

// 修改运营组
export function modifyOperationGroup(data = {}) {
  return request({
    url: `/ocean_novel_report/operation_group/${data.id}`,
    method: 'PUT',
    data
  })
}

// 获取运营者列表
export function getOperatorList(params = {}) {
  return request({
    url: `/ocean_novel_report/operation_group_user`,
    method: 'get',
    params
  })
}

// 添加运营者
export function addOperator(data = {}) {
  return request({
    url: `/ocean_novel_report/operation_group_user_add`,
    method: 'post',
    data
  })
}

// 删除运营者
export function deleteOperator(data = {}) {
  return request({
    url: `/ocean_novel_report/operation_group_user_del`,
    method: 'DELETE',
    data
  })
}

// 获取书籍归属列表
export function getBookOwnershipList(params = {}) {
  return request({
    url: `/ocean_novel_report/book`,
    method: 'get',
    params
  })
}

// 修改书籍
export function modifyBookOwnership(data = {}) {
  return request({
    url: `/ocean_novel_report/book/${data.id}`,
    method: 'PUT',
    data
  })
}

// 新增书籍
export function addBookOwnership(params = {}) {
  return request({
    url: `/ocean_novel_report/book`,
    method: 'post',
    params
  })
}

// 删除书籍
export function deleteBooks(id) {
  return request({
    url: `/ocean_novel_report/book/${id}`,
    method: 'delete'
  })
}

// 获取书名列表
export function getTitleList(params = {}) {
  return request({
    url: `/ocean_novel_report/book`,
    method: 'get',
    params
  })
}

// 投放位置列表
export function dropLocationList(params = {}) {
  return request({
    url: `/ocean_novel_report/positions`,
    method: 'get',
    params
  })
}

// 获取绑定关系列表
export function getBindingRelationList(params = {}) {
  return request({
    url: `/ocean_novel_report/bind`,
    method: 'get',
    params
  })
}

// 获取公众号列表
export function getTheListOfOfficialAccount(params = {}) {
  return request({
    url: `/ocean_novel_report/wechat_list`,
    method: 'get',
    params
  })
}

// 添加绑定关系
export function addReleaseRelationship(data = {}) {
  return request({
    url: `/ocean_novel_report/bind`,
    method: 'post',
    data
  })
}

// 修改投放关系
export function modifyReleaseRelationship(id, data = {}) {
  return request({
    url: `/ocean_novel_report/bind/${id}`,
    method: 'put',
    data
  })
}

// 删除投放关系
export function deleteReleaseRelationship(id) {
  return request({
    url: `/ocean_novel_report/bind/${id}`,
    method: 'DELETE'
  })
}

// 获取报表列表
export function getReportList(params = {}) {
  return request({
    url: `/ocean_novel_report/bind_report`,
    method: 'get',
    params
  })
}

// 导出报表
export function exportReport(data = {}) {
  return request({
    url: `/ocean_novel_report/export_bind_data`,
    method: 'post',
    data
  })
}
// 修改消耗
export function modifyConsumption(data = {}) {
  return request({
    url: `/ocean_novel_report/edit_consume`,
    method: 'PUT',
    data
  })
}

// 修改RIO标准
export function modifyStandard(data = {}) {
  return request({
    url: `/ocean_novel_report/edit_roi_standard`,
    method: 'PUT',
    data
  })
}
// 获取总计报表列表
export function getTotalReportList(params = {}) {
  return request({
    url: `/ocean_novel_report/bind_total_report`,
    method: 'get',
    params
  })
}

// 导出总计报表
export function exportTotalReport(data = {}) {
  return request({
    url: `/ocean_novel_report/export_bind_total_data`,
    method: 'POST',
    data
  })
}

// 获取平台
export function getPlatform(params = {}) {
  return request({
    url: `/common/specific_platform_list`,
    method: 'get',
    params
  })
}

export function launchTeamLeader(params = {}) {
  return request({
    url: `/ocean_novel_report/release_group_leader`,
    method: 'get',
    params
  })
}

// 删除投放组
export function deleteMy(id) {
  return request({
    url: `/ocean_novel_report/release_group/${id}`,
    method: 'delete'
  })
}

// 删除运营组
export function deleteOperationGroup(id) {
  return request({
    url: `/ocean_novel_report/operation_group/${id}`,
    method: 'delete'
  })
}
// 书籍汇总报表
export function oceannovelreportbookreport(params = {}) {
  return request({
    url: `/ocean_novel_report/book_report`,
    method: 'get',
    params
  })
}
// 导出书籍报表
export function oceannovelreportexportbookdata(data = {}) {
  return request({
    url: `/ocean_novel_report/export_book_data`,
    method: 'post',
    data
  })
}

// 运营汇总报表
export function oceanNovelReportbReleaseReport(params = {}) {
  return request({
    url: `/ocean_novel_report/release_report`,
    method: 'get',
    params
  })
}
// 导出运营报表
export function exportReleaseData(data = {}) {
  return request({
    url: `/ocean_novel_report/export_release_data`,
    method: 'post',
    data
  })
}
